module.exports = __webpack_public_path__ + "img/success.d0dee1cc.png";